import React from 'react';
import { log } from 'util';
import { connect } from 'react-redux';

import { signInCheck } from '../../../common/CheckUserStatus';
import { gtmPagePush, gtmEventPush, segmentEventPush, getProductItemPDP } from '../../../../modules/ga/GTMdatalayer';
import luxeScreen from '../../../../refresh/constants/luxeScreenType';
import RatingCard from '../../../../refresh/atoms/RatingCard';
import CustomerOpinion from '../../../../refresh/atoms/CustomerOpinion';
import Constants from '../../../../refresh/molecules/RateInfoDropdown/Constants';
import { getAggregateRating, getSubRatings } from '../../../../refresh/selectors/productpage';
import RateCalculationPopup from '../../../../refresh/organism/RateCalculationPopup';
import {
  getShowPDPRateSection,
  getEnableRating,
  getEnableReviewFlag,
  getShowReviewProdBtn,
  getShowRateProdBtn
} from '../../../../refresh/selectors/featureFlagsSelector';
import { getVariant, getFeatureVariant } from '../../../../refresh/organism/ABFeature/Feature';
import { Feature, Variant } from '../../../../refresh/organism/ABFeature';
import UnrateItems from '../../../../refresh/atoms/UnrateItems';
import { showModal } from '../../../../actions/shared/modal';
import ProductReviews from '../../../../refresh/organism/ProductReviews';

const isSignedIn = signInCheck();
class ProductRating extends React.Component {
  constructor(props) {
    super(props);
  }

  componentDidMount() {
    this.props.aggregateRating &&
      gtmEventPush({
        event: 'pdp_ratings_available',
        event_category: 'reviews & ratings interactions',
        event_action: 'pdp ratings available',
        event_label: 'activation event',
        page_type: 'product page'
      });
  }

  render() {
    const {
      data = {},
      aggregateRating,
      subRatings,
      showPDPRateSection,
      enableRating,
      customerWords,
      showModal,
      textReviews,
      imageReview,
      enableReview,
      showReviewProdBtn,
      showRateProdBtn
    } = this.props;
    const { textReview, totalReviews } = textReviews;
    const {
      fnlColorVariantData = {},
      fnlProductData = {},
      categories = [],
      brickCategory = '',
      rilfnlBreadCrumbList = {},
      styleType = '',
      name = '',
      baseProduct = '',
      images = [],
      code
    } = data;
    const { rilfnlBreadCrumb = [] } = rilfnlBreadCrumbList;
    const brickName = rilfnlBreadCrumb[2].name;
    const brickCode = rilfnlBreadCrumb[2].categoryCode ? rilfnlBreadCrumb[2].categoryCode : 83;
    const { brandName = '', color = '' } = fnlColorVariantData;
    const colorList = ['red', 'green', 'blue', 'black', 'white', 'grey'];
    const shopMoreLinks = [brickName, styleType, color, brandName];

    const { title: titleD, cta: ctaD } = Constants.default;
    const imageUrl = images ? images[0]?.url : '';
    const updatedImages = images.filter(el => el.format === 'superZoomPdp')[0];
    const noReviews = !(enableReview && (textReview?.length > 0 || imageReview?.totalReviews > 0));

    const rateProductModal = isWriteAReview => {
      showModal('rating-halfcard', {
        state: {
          deviceType: 'desktop',
          rating: '0',
          pageToDisplay: 'ratingHalfCard',
          displayFeedBackPage: true,
          isfromWriteFeedBack: true,
          isFeedBackSubmitted: true,
          isFromPDP: true,
          sourcePage: 'PDP',
          pageName: 'pdp screen',
          pageType: 'product page',
          isFromWriteReview: true,
          productDetails: {
            brandName,
            description: name,
            imageUrl,
            skuId: code,
            productCode: code,
            optionCode: code,
            brickCode
          }
        }
      });
      if (isWriteAReview) {
        gtmEventPush({
          event: 'reviews_rating_interactions',
          event_category: 'reviews_rating_interactions',
          event_action: 'Write overall review',
          product_id: code,
          ...(brickCode.length > 0 && { product_brick: brickCode }),
          product_name: name,
          pageType: 'product page',
          store_type: 'ajio'
        });
        // Segment Push event
        segmentEventPush({
          event: 'Review Widget Interaction',
          event_category: 'reviews_rating_interactions',
          event_action: 'Write overall review',
          component_name:'Product Rating',
          products:[{...getProductItemPDP(data)}],
          screen_name: 'pdp screen',
          // pageType: 'product page',
          store_type: 'ajio'
        });
      }
    };
    return (
      <div
        className="comp-section product-rating"
        id="productrating"
        style={{ position: 'relative' }}
        onClick={
          e=>{
            segmentEventPush({
              event: 'Rating Clicked',            
              page_source: 'Pdp Screen',          
              products:[{...getProductItemPDP(data)}],
              screen_name: 'Pdp Screen' 
            })  
          }
        }
      >
        {showPDPRateSection && (
          <>
            <h3 className="align-center" role="heading" aria-level="2">
              <span>Ratings</span>
            </h3>
            {aggregateRating && noReviews && customerWords && customerWords?.length > 0 && (
              <div className="rating-card-desktop store-link-row">
                <div>
                  <RatingCard
                    totalRatingCount={aggregateRating?.averageRating}
                    totalStarCount={aggregateRating?.numUserRatings}
                    isProgressBar
                    rateData={aggregateRating || ''}
                    isDesktop
                    customerWords={customerWords}
                    productData={data}
                  />
                  {enableRating && showPDPRateSection && (
                    <UnrateItems
                      enableReview={enableReview}
                      enableRating={enableRating}
                      showReviewProdBtn={showReviewProdBtn}
                      showRateProdBtn={showRateProdBtn}
                      isDesktop
                      rateProductModal={rateProductModal}
                      isRating={!!aggregateRating}
                      isCustomerWord={!!(customerWords && customerWords.length !== 0)}
                    />
              )}
                </div>
                {customerWords && customerWords.length !== 0 ? (
                  <>
                    <hr aria-hidden="true"/>
                    <CustomerOpinion
                      noReviews
                      subRating={subRatings || ''}
                      titleD={titleD}
                      isDesktop
                      customerWords={customerWords}
                      productCode={code}
                      productName={name}
                      product_id={code}
                      product_brick={brickCode}
                      aggregateRating={aggregateRating || ''}
                    />
                  </>
                ) : null}
              </div>
            )}
            {aggregateRating &&
              noReviews &&
              (customerWords === null ||
                customerWords === undefined ||
                customerWords?.length === 0) && (
                <div className="rating-card-desktop-no-rating store-link-row">
                  <div>
                    <RatingCard
                      totalRatingCount={aggregateRating?.averageRating}
                      totalStarCount={aggregateRating?.numUserRatings}
                      isProgressBar
                      rateData={aggregateRating || ''}
                      isDesktop
                      customerWords={customerWords}
                      productData={data}
                    />
                    {enableRating && showPDPRateSection && (
                      <UnrateItems
                        enableReview={enableReview}
                        enableRating={enableRating}
                        showReviewProdBtn={showReviewProdBtn}
                        showRateProdBtn={showRateProdBtn}
                        isDesktop
                        rateProductModal={rateProductModal}
                        isRating={!!aggregateRating}
                        isCustomerWord={!!(customerWords && customerWords.length !== 0)}
                      />
                )}
                  </div>
                </div>
              )}
            {aggregateRating && !noReviews && (
              <div className="rating-card-desktop store-link-row">
                <div className="rating-card-withReview">
                  <RatingCard
                    totalRatingCount={aggregateRating?.averageRating}
                    totalStarCount={aggregateRating?.numUserRatings}
                    isProgressBar
                    rateData={aggregateRating || ''}
                    isDesktop
                    customerWords={customerWords}
                    productData={data}
                  />
                  {enableRating && showPDPRateSection && (
                    <UnrateItems
                      enableReview={enableReview}
                      enableRating={enableRating}
                      showReviewProdBtn={showReviewProdBtn}
                      showRateProdBtn={showRateProdBtn}
                      isDesktop
                      rateProductModal={rateProductModal}
                      isRating={!!aggregateRating}
                      isCustomerWord={!!(customerWords && customerWords.length !== 0)}
                    />
              )}
                  {customerWords && customerWords.length !== 0 ? (
                    <>
                      <CustomerOpinion
                        noReviews={noReviews}
                        subRating={subRatings || ''}
                        titleD={titleD}
                        isDesktop
                        customerWords={customerWords}
                        productCode={code}
                        productName={name}
                        product_id={code}
                        product_brick={brickCode}
                        aggregateRating={aggregateRating || ''}
                      />
                    </>
                  ) : null}
                </div>
                <hr aria-hidden="true"/>
                {enableRating && enableReview && showPDPRateSection && (
                  <ProductReviews
                    totalRatingCount={aggregateRating?.averageRating}
                    totalStarCount={aggregateRating?.numUserRatings}
                    isProgressBar
                    rateData={aggregateRating || ''}
                    isDesktop
                    customerWords={customerWords}
                    textReview={textReview}
                    totalReviews={totalReviews}
                    imageReview={imageReview}
                    noReviews={noReviews}
                    subRating={subRatings || ''}
                    titleD={titleD}
                    productCode={code}
                    productName={name}
                    product_id={code}
                    product_brick={brickCode}
                    aggregateRating={aggregateRating || ''}
                    images={updatedImages}
                  />
                )}
              </div>
            )}
            {!aggregateRating && (
              <div className="rating-card-desktop-no-rating store-link-row">
                {enableRating && showPDPRateSection && (
                  <UnrateItems
                    enableReview={enableReview}
                    enableRating={enableRating}
                    showReviewProdBtn={showReviewProdBtn}
                    showRateProdBtn={showRateProdBtn}
                    isDesktop
                    rateProductModal={rateProductModal}
                    isRating={!!aggregateRating}
                    isCustomerWord={!!(customerWords && customerWords.length !== 0)}
                  />
                )}
              </div>
            )}
          </>
        )}
      </div>
    );
  }
}

const mapDispatchToProps = dispatch => {
  return {
    showModal: (name, config) => dispatch(showModal(name, config))
  };
};

const mapStateToProps = (state, ownProps) => {
  return {
    showPDPRateSection: getShowPDPRateSection(state?.flags),
    enableRating: getEnableRating(state?.flags,state),
    enableReview: getEnableReviewFlag(state) === 'ON',
    showReviewProdBtn: getShowReviewProdBtn(state?.flags),
    showRateProdBtn: getShowRateProdBtn(state?.flags)
  };
};

export default ProductRating = connect(mapStateToProps, mapDispatchToProps)(ProductRating);
